import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Heart } from "lucide-react";
import Navbar from "../components/Navbar";
import PosterCard from "../components/PosterCard";
import WheelBrowser, { cardRow } from "../components/clickwheel/WheelBrowser";
import { useTheme } from "../context/ThemeContext";
import Avatar from "../components/Avatar";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function Favorites() {
  const wheel = useTheme().skin === "clickwheel";
  const navigate = useNavigate();
  const { user } = useAuth();
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/favorites").then(({ data }) => setItems(data.items)).catch(() => setItems([]));
  }, [user?.favorites?.length]);

  return (
    <div className="min-h-screen bg-[var(--bg-base)]">
      <Navbar />
      <main className="px-4 lg:px-14 pt-6 pb-20" data-testid="favorites-page">
        <div className="flex items-center gap-3" data-testid="favorites-header">
          <Avatar user={user} size={48} className="flex-none border border-[var(--border-subtle)]" testid="favorites-avatar" />
          <div>
            <h1 className="flex items-center gap-2 font-head text-4xl sm:text-5xl tracking-wide text-[var(--text-primary)]">
              <Heart size={32} className="fill-[var(--accent)] text-[var(--accent)]" /> Favorites
            </h1>
            <p className="mt-1 text-[var(--text-secondary)]">Everything you've loved — your unlimited collection.</p>
          </div>
        </div>

        {items === null && <p className="mt-6 text-[var(--text-secondary)]">Loading…</p>}

        {items && items.length === 0 && (
          <div className="mt-20 flex flex-col items-center text-center text-[var(--text-secondary)]" data-testid="favorites-empty">
            <Heart size={44} className="mb-4 opacity-50" />
            <p className="text-lg">No favorites yet.</p>
            <p className="mt-1 text-sm">Tap the heart on any title to add it here.</p>
            <button onClick={() => navigate("/")} className="mt-5 rounded-md bg-[var(--accent)] px-6 py-2.5 font-bold uppercase tracking-wide text-white hover:bg-[var(--accent-hover)]" data-testid="favorites-browse-button">
              Browse titles
            </button>
          </div>
        )}

        {items && items.length > 0 && wheel && <WheelBrowser rows={items.map((it) => cardRow(it))} title="Favorites" testid="wheel-favorites" />}
        {items && items.length > 0 && !wheel && (
          <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6" data-testid="favorites-grid">
            {items.map((it) => (
              <div key={it.id} className="w-full [&>div]:w-full">
                <PosterCard item={it} />
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
